import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
    Photo, PhotoCollection, PhotoFilters, Product, ProductBase, ProductCollection, ProductFilters,
    StockPriceHistoryCollection
} from '../interfaces';
import { ApiResult, ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class ProductService extends ApiService {

  public get(id: string | number, filters: ProductFilters = {}): Observable<Product> {
    const queryString = this.convertObjectToQueryString(filters)
    return this.http.get<ApiResult<Product>>(`${this.apiUrl}/produits/${id}${queryString}`)
      .pipe(map((ar: ApiResult<Product>) => ar.result))
  }

  public getCollection(filters: ProductFilters = {}): Observable<ProductCollection> {
    const queryString = this.convertObjectToQueryString(filters)
    return this.http.get<ProductCollection>(`${this.apiUrl}/produits/${queryString}`)
  }

  public post(data: Partial<ProductBase>, filters: ProductFilters = {}): Observable<Product> {
    const queryString = this.convertObjectToQueryString(filters)
    return this.http.post<Product>(`${this.apiUrl}/produits/${queryString}`, data)
  }

  public patch(id: string | number, data: Partial<ProductBase>, filters: ProductFilters = {}): Observable<Product> {
    const queryString = this.convertObjectToQueryString(filters)
    return this.http.patch<Product>(`${this.apiUrl}/produits/${id}${queryString}`, data)
  }

  public delete(id: string | number): Observable<string> {
    return this.http.delete<string>(`${this.apiUrl}/produits/${id}`)
  }

  public getChartData(id: string | number, filters: any = {}): Observable<any> {
    const queryString = this.convertObjectToQueryString(filters)
    return this.http.get<any>(`${this.apiUrl}/produits/${id}/chart-data${queryString}`)
  }

  public getExportExcel(): Observable<any> {
      return this.http.get<any>(`${this.apiUrl}/produits/export_xlsx`, {responseType: 'blob' as 'json'})
  }

  public getPhotoCollection(id: string | number, filters: PhotoFilters = {}): Observable<PhotoCollection> {
    const queryString = this.convertObjectToQueryString(filters)
    return this.http.get<PhotoCollection>(`${this.apiUrl}/produits/${id}/photos${queryString}`)
  }

  public postPhoto(data: Partial<ProductBase>, filters: PhotoFilters = {}): Observable<Photo> {
    const queryString = this.convertObjectToQueryString(filters)
    return this.http.post<Photo>(`${this.apiUrl}/produits/${queryString}`, data)
  }

  public postGenererEbay(id: string | number, filters: any = {}): Observable<any> {
    const queryString = this.convertObjectToQueryString(filters)
    return this.http.post<any>(`${this.apiUrl}/produits/${id}/generer-ebay${queryString}`, {})
  }

  public postValidateEbayModification(id: string |number): Observable<any> {
      return this.http.post<any>(`${this.apiUrl}/produits/${id}/accuser-modification-ebay`, {})
  }

  public getStockPriceHistory(filters: any = {}): Observable<StockPriceHistoryCollection> {
    const queryString = this.convertObjectToQueryString(filters)
    return this.http.get<StockPriceHistoryCollection>(`${this.apiUrl}/prix-historique/${queryString}`)
  }
}
